<script setup lang="ts">
import type { ICellRendererParams } from "ag-grid-community";
import { computed } from "vue";

import UserEditor from "~/components/dumb/UserEditor.vue";
import TaskClickWrapper from "~/components/visualization/components/TaskClickWrapper.vue";
import { EditorMode } from "~/shared/enums";
import type { PropertyAnyUser, VisualizationItemTask } from "~/shared/types";
import { useAsyncTask } from "~/utils/entityIncrementalLoading";

const props = defineProps<{
  params: ICellRendererParams<VisualizationItemTask> & {
    property: PropertyAnyUser;
    editorMode: EditorMode;
  };
}>();

const { task } = useAsyncTask(computed(() => props.params?.data?.duid));
</script>

<template>
  <TaskClickWrapper v-if="task" :task="task" :editor-mode="params.editorMode">
    <template #default="args">
      <UserEditor
        v-if="!params.data?.absentee"
        v-bind="args"
        :property="params.property"
        :tasks="[task]"
        :editor-mode="params.editorMode"
        class="h-full" />
    </template>
  </TaskClickWrapper>
</template>
